import { useQuery } from '@tanstack/react-query';
import useHttpClient from './useHttpClient';

export interface IDocument {
  documentId: {
    native: number;
    partner: number | null;
  };
  filename: string,
  size: number,
  projectId: {
    native: number;
    partner?: number;
  };
  uploaderId: {
    native: number;
    partner: number | null;
  };
  folderId: {
    native: number;
    partner: number | null;
  };
  folderName?: string;
  uploadDate: string,
  hashtags: string[],
  uploaderFullname: string,
}

interface IRecentDocuments {
  count: number;
  offset: number;
  limit: number;
  hasMore: boolean;
  requestedFields: string;
  items: IDocument[];
}

/**
 * TanStack Query version of useQueryRecentDocuments
 * Fetches recent documents using HTTP client with parameter-based reactivity
 */
const useQueryRecentDocuments = (projectId: number | null) => {
  const httpClient = useHttpClient();

  return useQuery<IRecentDocuments>({
    queryKey: ['recentDocuments', projectId],
    queryFn: async () => {
      if (!projectId) {
        throw new Error('Project ID not set');
      }
      const response = await httpClient.get(`/RecentlyOpenedDocuments?projectId=${projectId}&limit=5`);
      return response.data;
    },
    enabled: projectId !== null, // Only fetch when project ID is provided
  });
};

export default useQueryRecentDocuments;
